export const sounds = [
  {
    filename: 'ba-dum-tsss.mp3',
    cover: 'ba-dum-tsss.png',
  },
  {
    filename: 'bach-toccata_and_fugue_in_d_minor.mp3',
    cover: 'bach-toccata_and_fugue_in_d_minor.jpg',
  },
  {
    filename: 'black-box.mp3',
    cover: 'black-box.jpg',
  },
  {
    filename: 'eralash.mp3',
    cover: 'eralash.jpg',
  },
  {
    filename: 'news.mp3',
    cover: 'news.jpg',
  },
  {
    filename: 'sam_brown-stop.mp3',
    cover: 'sam_brown-stop.jpg',
  },
  {
    filename: 'wait-for-me.mp3',
    cover: 'wait-for-me.jpg',
  },
  {
    filename: 'x-files-theme.mp3',
    cover: 'x-files.png',
  },
  {
    filename: 'laughing-hyena.mp3',
    cover: 'laughing-hyena.jpg',
  },
  {
    filename: 'sad-trombone.mp3',
    cover: 'sad-trombone.jpg',
  },
  {
    filename: 'fort-boyard.mp3',
    cover: 'fort-boyard.jpg',
  },
  {
    filename: 'mission-impossible-theme.mp3',
    cover: 'mission-impossible-theme.jpg',
  },
  // {
  //   filename: 'taylor_swift-shake_it_off.mp3',
  //   cover: 'taylor_swift-shake_it_off.jpg',
  // },
  {
    filename: 'ennio_morricone-the_good_the_bad_and_the_ugly.mp3',
    cover: 'ennio_morricone-the_good_the_bad_and_the_ugly.jpg',
  },
  {
    filename: 'cricket-sound.mp3',
    cover: 'cricket-sound.png',
  },
  {
    filename: 'dial-up_modem.mp3',
    cover: 'dial-up_modem.jpg',
  },
  // {
  //   filename: 'toxic-flute.mp3',
  //   cover: 'toxic-flute.jpg',
  // },
  // {
  //   filename: 'toxic-lips.mp3',
  //   cover: 'toxic-lips.jpg',
  // },
  {
    filename: 'bandera.mp3',
    cover: 'bandera.jpg',
  },
  {
    filename: 'surprise-surprise.mp3',
    cover: 'surprise-surprise.jpg',
  },
  {
    filename: 'stupka.mp3',
    cover: 'stupka.jpg',
  },
  // Dina don't want this
  // {
  //   id: '0017',
  //   filename: 'pornhub-intro.mp3',
  //   cover: 'pornhub-intro.png'
  // }
].map((sound, i) => ({ ...sound, id: i + 1 }))
